const ProductPagination = ({ totalPages }) => ({
  currentPage: null,

  pages: [],

  init() {
    const url = window.location.search;
    const params = new URLSearchParams(url);
    const page = Math.abs(parseInt(params.get('page'), 10)) || 1;

    this.pages = [page];
    this.currentPage = page;
  },

  pageNext: {
    ['x-show']() {
      return this.isNext();
    },
  },

  pageNextBtn: {
    ['@click']() {
      this.handleNext();
    },
  },

  pagePrev: {
    ['x-show']() {
      return this.isPrev();
    },
  },

  pagePrevBtn: {
    ['@click']() {
      this.handlePrev();
    },
  },

  isNext() {
    const page = this.pages[this.pages.length - 1];
    return page < totalPages;
  },

  isPrev() {
    const page = this.pages[0];
    return page > 1;
  },

  handleNext() {
    this.currentPage = this.pages[this.pages.length - 1] + 1;
    this.setParams();
    this.getView()
      .then((doc) => {
        const products = document.getElementById('products');
        const products_ = doc.getElementById('products');
        products.append(...products_.children);
        this.pages = [...this.pages, this.currentPage];
        this.getYotpo();
      })

      .catch((x) => console.error(x));
  },

  handlePrev() {
    this.currentPage = this.pages[0] - 1;
    this.setParams();
    this.getView()
      .then((doc) => {
        const products = document.getElementById('products');
        const products_ = doc.getElementById('products');
        products.prepend(...products_.children);
        this.pages = [this.currentPage, ...this.pages];
        this.getYotpo();
      })
      .catch((x) => console.error(x));
  },

  getYotpo() {
    setTimeout(() => {
      yotpo.initWidgets();
    }, 500);
  },

  getView() {
    const url = window.location.href;
    return fetch(url)
      .then((x) => x.text())
      .then((x) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(x, 'text/html');
        return doc;
      })
      .catch((x) => console.error(x));
  },

  setParams() {
    const path = location.pathname;
    const params = new URLSearchParams(window.location.search);
    params.set('page', this.currentPage);
    window.history.pushState({}, '', `${path}?${params}`);
  },
});

export default ProductPagination;
